import { useTranslation } from "react-i18next";
import "../styles/projects/project-main.css"
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButtonComponent = () => {
  const { t } = useTranslation();
  return (
    <>
        <Button variant="outline-light" href="/" className="back-button">
            <FontAwesomeIcon icon={faArrowLeft} className="button-icon-padding-previous" />
            {t('backToHomepage')}
        </Button>
    </>
  )
}

export default BackButtonComponent